import React from "react";
import { IJiraAttachment } from "../../common/interface";
import { downloadJiraFile } from "../../utils/helper";
import "./style.scss";

type IFilePreviewProps = {
  file: IJiraAttachment;
  onClick?: () => void;
};

const formatDate = (dateStr: string) => {
  if (!dateStr) return null;
  const date = new Date(dateStr);
  return date.toLocaleString(undefined, {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

const getFileIcon = (mimeType: string) => {
  if (mimeType === "application/json") return "{}";
  if (mimeType === "binary/octet-stream") return "</>";
  if (mimeType.startsWith("video/")) return "🎬";
  return "📦";
};

const FilePreview: React.FC<IFilePreviewProps> = ({ file, onClick }) => {
  const handleFilePreviewClick = () => {
    if (file?.content) {
      downloadJiraFile(file);
    }
  };
  return (
    <button
      className="file-card"
      onClick={onClick}
      onDoubleClick={handleFilePreviewClick}
    >
      <div className="file-icon">{getFileIcon(file?.mimeType)}</div>
      <div className="file-info">
        <div className="file-name">{file?.filename}</div>
        <div className="file-timestamp">{formatDate(file?.created)}</div>
      </div>
    </button>
  );
};

export default FilePreview;
